import * as React from "react";
import type { SVGProps } from "react";
const SvgLinePointIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="line_point_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M308.139 369.493a87.637 87.637 0 0 0-18.56 28.075L224.81 554.795a88.576 88.576 0 0 0 16.853 93.866c23.381 25.174 59.136 33.963 91.307 22.443l162.005-58.07a86.492 86.492 0 0 0 32.128-20.522L759.68 357.12l.128-.128a161.536 161.536 0 0 0 0-225.835c-64.47-65.536-160.939-57.13-219.093 1.963L308.139 369.493zm40.96 110.208 19.925-48.341L601.6 194.987c27.733-28.16 69.59-30.123 97.323-1.92 27.733 28.16 27.733 73.856 0 102.058l-232.576 235.35-52.523 18.816-109.568 39.253 44.843-108.843zM128 768a42.667 42.667 0 1 0 0 85.333A42.667 42.667 0 0 0 128 768zm128 0a42.667 42.667 0 1 0 0 85.333A42.667 42.667 0 0 0 256 768zm85.333 42.667a42.667 42.667 0 1 1 85.334 0 42.667 42.667 0 0 1-85.334 0zM512 768a42.667 42.667 0 1 0 0 85.333A42.667 42.667 0 0 0 512 768zm85.333 42.667a42.667 42.667 0 1 1 85.334 0 42.667 42.667 0 0 1-85.334 0zM768 768a42.667 42.667 0 1 0 0 85.333A42.667 42.667 0 0 0 768 768zm85.333 42.667a42.667 42.667 0 1 1 85.334 0 42.667 42.667 0 0 1-85.334 0z"
    />
  </svg>
);
export default SvgLinePointIcon;
